import { Tag } from "@blueprintjs/core"
import CustomCard from "components/Atoms/CustomCard"
import NewTag from "components/Atoms/NewTag"
import StyledLink from "components/Atoms/StyledLink"
import Actions from "components/Common/Actions"
import Error from "components/Common/Error"
import ReactTableHeader from "components/Common/ReactTableHeader"
import NewResourceButton from "components/Organisms/AddResourceButton"
import SerialColumn from "components/Organisms/table/SerialColumn"
import { useAllCompaniesListQuery } from "generated/graphql"
import { orderBy } from "lodash-es"
import React from "react"
import { useNavigate } from "react-router-dom"
import ReactTable from "react-table"
export default function Companies() {
  const navigate = useNavigate()
  const COLUMNS = [
    SerialColumn,
    {
      accessor: "actions",
      maxWidth: 50,

      Cell: row => (
        <Actions
          item={{ name: "company", id: row.original.id }}
          actions={[{ name: "Edit Company", handler: navigate, icon: "edit" }]}
        />
      ),
    },
    {
      Header: "Name",
      accessor: "name",
      width: 400,
      Cell({ value, original }) {
        return (
          <>
            <StyledLink to={original.id}>{value}</StyledLink>
            <NewTag createdAt={original.createdAt} />
          </>
        )
      },
    },
    {
      Header: "Codename",
      accessor: "codename",
    },
    {
      Header: "Display Name",
      accessor: "displayName",
    },

    {
      Header: "Departments",
      accessor: "groups",
      Cell: row => {
        return (
          <span>
            {row.original.departments.map(v => (
              <Tag
                key={v.id}
                className="ml-2"
                minimal={true}
                round={true}
                intent="primary"
              >
                {v.name}
              </Tag>
            ))}
          </span>
        )
      },
    },
  ]

  const { data, loading, error } = useAllCompaniesListQuery()
  const list = data?.allCompanies || []
  if (error) return <Error />

  const ordered = orderBy(list, d => parseInt(d?.id), "desc")
  return (
    <CustomCard className="p-0">
      <ReactTableHeader icon="office" title="Companies">
        <NewResourceButton module="company" />
      </ReactTableHeader>
      <ReactTable
        pageSize={list?.length > 15 ? list?.length : 15}
        loading={loading}
        showPagination={false}
        className="mt-0 text-center vt-master-table"
        data={ordered}
        columns={COLUMNS}
      />
    </CustomCard>
  )
}
